<div
  *ngIf="control; else notControl"
  class="input-group-container 1"
  [ngClass]="{
    error: control.touched && control.errors && control.validator,
    success: control.touched && !control.errors && control.validator
  }"
>
  <label *ngIf="label" [for]="idInput" class="label">{{ label }}</label>

  <div class="input-group">
    <input
      [formControl]="control"
      autocomplete="off"
      [placeholder]="placeholder"
      [type]="handleInputType()"
      [id]="idInput"
      class="input"
      [maxlength]="maxlength"
      [minlength]="minlength"
      (keypress)="numberOnly($event, inputype)"
      *ngIf="inputype !== 'code'"
      (paste)="(!blockPaste)"
      (cut)="(!blockCut)"
      (copy)="(!blockCopy)"
      (keypress)="keyPressNumbers($event)"
    />

    <code-input
      *ngIf="inputype === 'code'"
      [isCodeHidden]="false"
      [codeLength]="6"
      (codeChanged)="onCodeChanged($event)"
      (codeCompleted)="onCodeCompleted($event)"
      [code]="control.value"
      [ngClass]="{ 'code-error': control.touched && control.errors }"
      [disabled]="disabled"
    >
    </code-input>

    <div *ngIf="control.value && autocomplete.length" class="autocomplete">
      <p *ngFor="let item of autocomplete" (keydown.enter)="setValue(item)" (click)="setValue(item)">
        {{ item.name }}
      </p>
    </div>

    <i-feather
      *ngIf="iconMain"
      [ngClass]="{
        'icon-input': true,
        'icon-pointer': isValidPassword || addChangeIcon,
        'color-secondary-500': addChangeIcon
      }"
      [name]="iconMain"
      (keydown.enter)="onClickIcon()"
      (click)="onClickIcon()"
    ></i-feather>
  </div>

  <span
    class="text-caption"
    *ngIf="
      !control.validator ||
      (!(control.touched && control.errors) &&
        !(control.touched && successMessage))
    "
    >{{ textCaption }}</span
  >

  <span class="error-message" *ngIf="control.touched && control.errors">{{
    displayError(control.errors)
  }}</span>

  <span
    class="success-message"
    *ngIf="
      successMessage && control.touched && !control.errors && control.validator
    "
    >{{ successMessage }}</span
  >
</div>

<ng-template #notControl>
  <div class="input-group-container">
    <label *ngIf="label" [for]="idInput" class="label">{{ label }}</label>

    <div class="input-group">
      <input
        [type]="inputype"
        [id]="idInput"
        class="input"
        [value]="value"
        [disabled]="disabled"
        (paste)="(!blockPaste)"
        (cut)="(!blockCut)"
        (copy)="(!blockCopy)"
        (keypress)="keyPressNumbers($event)"
      />

      <i-feather
        *ngIf="iconMain"
        class="icon-input"
        [name]="iconMain"
        [ngClass]="{
          'icon-pointer': addChangeIcon,
          'color-secondary-500': addChangeIcon
        }"
        (keydown.enter)="onClickIcon()"
        (click)="onClickIcon()"
      ></i-feather>
    </div>
  </div>
</ng-template>
